import { listInterview, markReadInterview } from "@endpoints/interview.service";
import { groupedGeneralMeetings } from "../SchedulingSection/SchedulingSection";
import { useEffect, useRef, useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { isObjectEmpty } from "@utils/helperFunction";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  IGetInterviewByIdResponse,
} from "@endpoints/types/interview.type";
import { EnumUserTypes } from "@utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { useSnackbar } from "notistack";

export function getMeetingStatus(item: IGetInterviewByIdResponse) {
  if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? !item?.isCandidateConfirm && !item?.isCompanyConfirm
      : !item?.isCandidateConfirm && !item?.isRecruiterAgencyConfirm
  ) {
    return {
      label: "Action Required",
      textStyle: "text-orange-400",
      buttonStyle: "border-orange-400",
    };
  } else if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? item?.isCandidateConfirm && item?.isCompanyConfirm
      : item?.isCandidateConfirm && item?.isRecruiterAgencyConfirm
  ) {
    return {
      label: "Accepted",
      textStyle: "text-green-500",
      buttonStyle: "border-green-500",
    };
  } else if (
    item?.interviewStatus !== "Declined" &&
      item?.slotSelectionType === "general"
      ? item?.isCompanyConfirm || item?.isRecruiterAgencyConfirm
      : item?.isRecruiterAgencyConfirm || item?.isCandidateConfirm
  ) {
    return {
      label: "Pending",
      textStyle: "text-blue-500",
      buttonStyle: "border-blue-500",
    };
  } else if (item?.interviewStatus === "Declined") {
    return {
      label: "Declined",
      textStyle: "text-red-500",
      buttonStyle: "border-red-500",
    };
  }
}
const data = {
  "candidate": {
    "isRead": false
  },
  "recruiter": {
    "isRead": false
  },
  "hiringCompany": {
    "isRead": false
  }
}


export function getReadStatus({
  data,
  role
}: {
  data: {
    candidate: {
      isRead: boolean;
    };
    recruiter: {
      isRead: boolean;
    };
    hiringCompany: {
      isRead: boolean;
    },
  }
  role: EnumUserTypes
}) {
  switch (role) {
    case EnumUserTypes.CANDIDATE:
      return data?.candidate?.isRead
    case EnumUserTypes.HIRING_COMPANY:
      return data?.hiringCompany?.isRead
    case EnumUserTypes.RECRUITER:
      return data?.recruiter?.isRead

    default:
      return data?.candidate?.isRead;
  }
}

export function getRoleForPayload({
  userType
}: {
  userType: EnumUserTypes
}) {
  switch (userType) {
    case EnumUserTypes.CANDIDATE:
      return 'candidate'
    case EnumUserTypes.HIRING_COMPANY:
      return 'hiringCompany'
    case EnumUserTypes.RECRUITER:
      return 'recruiter'

    default:
      return null
  }
}

const ScheduleCard = ({ item, index, userRole }) => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate();
  const isHiringCompanyInvolved = !!item?.hiringCompanyId?._id;
  const attendees = isHiringCompanyInvolved ? ["RA", "CA", "HC"] : ["RA", "CA"];
  const buttonInfo = getMeetingStatus(item);
  const isRead = getReadStatus({ data: item?.readStatus, role: userRole })

  const handleClick = async () => {
    navigate(`/meeting-details?id=${item?._id}`)
    try {
      await markReadInterview({
        interviewId: item?._id,
        role: getRoleForPayload({ userType: userRole })
      })
    } catch (error) {
      enqueueSnackbar(error, { variant: 'error' })
      console.error('Error marking interview', error)
    }
  }

  return (
    <div
      onClick={handleClick}
      className={`items-center p-3 grid grid-cols-[1fr_1fr_1fr_1fr_0.7fr] cursor-pointer hover:bg-gray-50 ${index !== 0 ? "border-t" : ""
        }`}
    >
      <span className={`font-medium text-light-black text-xs`}>
        {dayjs(item?.createdAt).format("Do")}&nbsp;&nbsp;
        {dayjs(item?.createdAt).format("dddd")}{" "}
        {dayjs(item?.createdAt).format("hh:mm a")}
        {
          !isRead ?
            <span className="text-secondary text-xs font-medium ml-2">New</span>
            :
            null
        }
      </span>
      <span className="font-medium text-xs text-primary flex-1">
        {item?.meetingTitle}
      </span>
      <span className="font-medium text-xs text-light-black flex-1">
        {item?.jobTitle}
      </span>
      <div className="flex flex-1 items-center gap-2">
        {attendees?.map((item) => {
          return (
            <div
              key={item}
              className="flex items-center justify-center h-8 w-8 text-xs font-bold border rounded-full border-light-grey text-light-black"
            >
              {item}
            </div>
          );
        })}
      </div>
      {/* Status button container */}
      <div
        className={`rounded-md flex items-center justify-center px-2.5 font-medium w-max py-1 text-xs border-[1.2px] ${buttonInfo?.textStyle} ${buttonInfo?.buttonStyle}`}
      >
        {buttonInfo?.label}
      </div>
    </div>
  );
};

const ScheduleSection = () => {
  const itemRefs = useRef([])
  const userRole = useSelector((state: RootState) => state.auth.user.userType);
  const [isEventLoading, setIsEventLoading] = useState(true);
  const [schedulingPolls, setSchedulingPolls] = useState([]);

  useEffect(() => {
    if (schedulingPolls?.length) {
      const title = dayjs().format('MMMM YYYY')
      itemRefs.current[title]?.scrollIntoView({
        behavior: "smooth",
        block: 'center',
      });
    }
  }, [schedulingPolls])

  useEffect(() => {
    listInterview({
      isSchedule: true,
    })
      .then((response) => {
        const { success, data } = response;
        if (success) {
          // data?.map((item) => {
          //   deleteInterview(item?._id);
          // });
          setSchedulingPolls(() => groupedGeneralMeetings(data));
          console.log('schedulingPolls', data, groupedGeneralMeetings(data))
          // setEvents(() => formatEvents(data));
        }
      })
      .finally(() => setIsEventLoading(false));
  }, []);


  return (
    <div className="items-center w-full">
      <div className="grid grid-cols-[1fr_1fr_1fr_1fr_0.7fr] w-full border-b p-3 mb-4">
        <span className="font-semibold text-xs text-gray-500">Date/Time</span>
        <span className="font-semibold text-xs text-gray-500">
          Meeting title
        </span>
        <span className="font-semibold text-xs text-gray-500">
          Position title
        </span>
        <span className="font-semibold text-xs text-gray-500">Attendees</span>
        <span className="font-semibold text-xs text-gray-500">Status</span>
      </div>
      {isEventLoading ? (
        <div className="flex items-center justify-center flex-1 flex-col">
          <LoadingAnimation color="#2e2e2e" />
        </div>
      ) : isObjectEmpty(schedulingPolls) ? (
        <div className="font-medium text-light-black text-sm h-[calc(100vh-300px)] flex flex-col justify-center items-center">
          No scheduling poll found.
        </div>
      ) : (
        <div
          className="flex flex-col gap-7">
          {
            schedulingPolls?.map((item) => {
              return <div key={item?.title}
                ref={(el) => {
                  if (el) itemRefs.current[item?.title] = el
                }}
                className="flex flex-col">
                <div
                  className={`flex items-center py-1.5 px-3 gap-4 bg-[#F1F5F9] rounded-sm`}
                >
                  <label className="font-medium text-xs">{item?.title}</label>
                </div>
                {!item?.data?.length ?
                  <span className="text-xs font-medium m-auto mt-4 text-light-black">No meeting scheduled</span>
                  :
                  item?.data.map((meeting, meetingIndex) => (
                    <ScheduleCard key={meeting?._id} item={meeting} index={meetingIndex} userRole={userRole} />
                  ))
                }
              </div>
            })
          }
        </div>
      )}

      {/* <div className="flex-grow">
        {Object.keys(groupedMeetings).map((year, yearIndex) => (
          <div key={year} className="flex flex-col gap-10">
            {Object.keys(groupedMeetings[year]).map((month, monthIndex) => (
              <div key={month}>
                <div
                  className={`flex items-center py-1.5 px-3 gap-4 bg-[#F1F5F9] rounded-sm`}
                >
                  <label className="font-medium text-sm">
                    {month} {year}
                  </label>
                </div>
                List of scheduled meetings
                <div className="flex flex-col mt-4">
                  {groupedMeetings[year][month].map((meeting, index) => (
                    <ScheduleCard key={index} item={meeting} index={index} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ScheduleSection;
